import React, { createContext } from 'react';

export const configureIfCan =
  (ErrorBoundary: React.ComponentType<any> = React.Fragment) =>
  (Component) => {
    return Component ? (
      ErrorBoundary !== React.Fragment ? (
        <ErrorBoundary name="workspaceLayout">
          <Component />
        </ErrorBoundary>
      ) : (
        <Component />
      )
    ) : null;
  };

export const ContentContainerContext = createContext(undefined);

export default configureIfCan;
